import { toast } from 'react-toastify';
import { Post } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';
import { PostTweetTypes } from './types';
import { SOUND } from '../../utils/source-constants';

export async function playSound(post: Post, tweetTypes: PostTweetTypes) {
    const getDetails = <T extends Record<string, any>>(base: Record<string, T>, platform: string) => {
        return base[platform] && (base[platform][post.username as keyof T] as string);
    };

    const sound = localStorage.getItem(`customSound_${post.username}`) || getDetails(SOUND, post.platform);

    if (post.tweetType && !tweetTypes[post.username].soundTweetTypes.has(post.tweetType)) {
        return;
    }

    if (sound) {
        console.log('Playing sound:', sound);
        const audio = new Audio(sound);
        audio.play().catch((error) => {
            console.error('Error playing sound:', error);
            toast.error('Unable to play sound. Please interact with the page first.');
        });
    }
}
